import Error from '../model/Error';
import axios from 'axios';

export default class IsbjKindergartenConfigsRepository {
    static find(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/isbj/kindergartens`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, kindergartenConfigs) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/isbj/kindergartens`, {
                    configs: kindergartenConfigs.map((kindergartenConfig) => {
                        return {
                            kindergarten: kindergartenConfig.kindergarten.id,
                            isbjNumber: kindergartenConfig.isbjNumber,
                            costs: kindergartenConfig.costs.map((cost) => cost.id),
                        };
                    }),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
